module.exports = __webpack_public_path__ + "static/img/kawachi_03.7da7ee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/kawachi_03.jpg
// module id = RN0N
// module chunks = 0